// extracted by mini-css-extract-plugin
export default {"row":"ANhjMFO_U_Tkxmd3WErU","header":"m9sketxyrIusqLcZR8yE","action":"L57Nv2FMA6c986_47dES","ordinal":"IKs4fmSGGz3NXb72pvFN"};